<template>
  <v-container class="px-7 py-0">
    <v-form ref="documentsFilterForm">
      <v-row class="pt-2 pb-2 px-0">
        <v-col class="pt-0 pb-0" cols="12" sm="6" md="2">
          <label>Data entre</label>
          <v-menu
            ref="dtI"
            v-model="dtI"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateIFormatted"
                dense
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="dateI = parseDate(dateIFormatted)"
                :rules="[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateI" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="pt-0 pb-0"  cols="12" sm="6" md="2">
          <label>até</label>
          <v-menu
            ref="dtF"
            v-model="dtF"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFFormatted"
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="dateF = parseDate(dateFFormatted)"
                :rules="[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateF" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="pt-0 pb-0"  cols="12" sm="12" md="4">
          <label>Nome do arquivo</label>
          <v-text-field
            v-model="formData.search"
            prepend-inner-icon="mdi-magnify"
            placeholder="Nome do arquivo"
            single-line
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="pt-0 pb-0"  cols="12" sm="6" md="2">
          <label>Tipo de Documento</label>
          <v-select
            v-model="formData.tipo"
            :items="docTiposFilter"
            placeholder="Selecione"
            outlined
            item-text="descricao"
            item-value="id"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
          ></v-select>
        </v-col>
        <v-col class="pt-0 pb-0"  cols="12" sm="6" md="3">
          <label>Módulo</label>
          <v-select
            v-model="formData.modulo"
            :items="modulosList"
            item-value="value"
            item-text="label"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col class="pt-0 pb-0"  cols="12" sm="6" md="3">
          <label>Prestador</label>
          <v-select
            v-model="formData.prestador"
            :items="prestadoresFilter"
            item-value="id"
            item-text="prest_nome"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col class="pb-0 px-2" cols="3" style="padding-top: 20px;">
              <v-spacer></v-spacer>
              <v-btn
                small 
                height="32px"
                color="primary"
                class="px-1 mr-2"
                depressed
                @click="sendFilter()"
                >Filtrar</v-btn>
              <v-btn
                outlined
                small 
                height="32px"
                color="primary"
                class="px-1 ml-2"
                depressed
                @click="clearFilters()"
                >Limpar Filtro</v-btn>
          </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import moment from "moment";
import { mask } from 'vue-the-mask'
import { mapState, mapGetters } from "vuex";
export default {
  directives: {
    mask
    },
  data() {
    return {
      formData: {
        search: "",
        modulo: null,
        tipo: null,
        prestador: "",
        data_inicio: null,
        data_final: null,
      },
      dateF: null,
      dateFFormatted: null,
      dateI:null,
      dateIFormatted: null,
      dtI: false,
      dtF: false,
      modulosFilter:[],
      prestadoresFilter:[],
      docTiposFilter:[],
      modulosList:[]
    }
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules
    }),
    ...mapGetters({
      getModulosList: "permissions/getModulosList",
      getPermissoesModulo: "permissions/getPermissoesModulo"
    }),
  },
  beforeMount(){
    let array = this.getModulosList()
    array.unshift({value: null, label: "Selecione"});
    this.modulosList = array;
    this.prestadoresFilter = Array.from(this.prestadores)
        if (this.prestadoresFilter.length==1) {
          this.formData.prestador = this.prestadoresFilter[0].id
          this.getList(this.formData, 1)
        }  else {
          this.prestadoresFilter.unshift({id: "", prest_nome: "Selecione"})
        }
  },
  props: {
    docTipos: Array,
    formatDate: Function,
    getList: Function,
    modules: Array,
    parseDate: Function,
    prestadores: Array,
    permission: Object
  },
  watch: {
    dateF(val){
      if (!val) {
        this.dateI = null
        this.dateFFormatted = null
      } else {
        let date = moment(val).add(-180, 'day').format('YYYY-MM-DD')
        if (!(Date.parse(this.dateI) <= Date.parse(val) && Date.parse(this.dateI) > Date.parse(date)))
          this.dateI = date
        this.dateFFormatted = this.formatDate(val)
      }
    },
    dateFFormatted(val){
      this.formData.data_final = this.parseDate(val)
    },
    dateI(val){
      if (!val) {
        this.dateF = null 
        this.dateIFormatted = null
      } else { 
        let date = moment(val).add(180, 'day').format('YYYY-MM-DD');
        if (!(Date.parse(val) <= Date.parse(this.dateF) && Date.parse(date) > Date.parse(this.dateF)))
          this.dateF = date
        this.dateIFormatted = this.formatDate(val)
      }
    },
    dateIFormatted(val){
      this.formData.data_inicio = this.parseDate(val)
    },
    docTipos: {
      deep: true,
      handler(val){
      this.docTiposFilter = Array.from(val)
      this.docTiposFilter.unshift({id: null, descricao: "Selecione"})
      }
    },
    modules:{
      deep: true,
      handler(modules){
        let val = Object.keys(this.permission)
        let allowedModule = modules.filter(el => el.value == val.find(val => val == el.value))
        this.modulosFilter = Array.from(allowedModule)
        this.modulosFilter.unshift({value: "", label: "Selecione"})
      }
    },
    prestadores:{
      deep: true,
      handler(val){
        this.prestadoresFilter = Array.from(val)
        if (this.prestadoresFilter.length==1) {
          this.formData.prestador = this.prestadoresFilter[0].id
          this.getList(this.formData, 1)
        }  else {
          this.prestadoresFilter.unshift({id: "", prest_nome: "Selecione"})
        }
      }
    },
  },
  methods: {
    sendFilter(){
      if(this.$refs.documentsFilterForm.validate()){
        this.formData.offset = 1;
        this.getList(this.formData, 1);
      }
    },
    clearFilters(){
      this.formData = {
        search: "",
        modulo: null,
        tipo: null,
        prestador: "",
        data_inicio: null,
        data_final: null,
        offset: 1
      }
    }
  }
};
</script>
